import React, { useState } from 'react';
import DataEntry from '../add_customer';

const isEditting = true;

export default function DetailsPage(props){
    const [customerDetails] = useState(props);
    return(
        <div>
            <DataEntry 
                customerDetails={customerDetails.location.state} 
                isEditting={isEditting}
            />
        </div>
    );
}